// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"7279676b","213":"02548fd4","415":"59a0792e","437":"6c1e3bee","525":"6be707a6","643":"a7a6aa51","682":"8ee74db0","996":"6cbb218c"}[chunkId] + ".chunk.js";
};